import { BASELINE_SIDE } from "@sagot/constants";
import { useState } from "react";
import { DIFF_LIVE } from "../p4-types";
import { useVersions } from "../use-workflows-p4";
import { VersionCompare } from "../versions/version-compare";

interface CompareDefaultDialogProps {
  workflowId: string;
  /** The builder holds edits that are not saved yet (a comparison with the draft reads the saved one). */
  unsaved?: boolean;
  onClose: () => void;
  onCloseAutoFocus?: (event: Event) => void;
}

/** "Compare with default": the version that runs next to the default it started from; either side can be changed to any version. */
export function CompareDefaultDialog({ workflowId, unsaved = false, onClose, onCloseAutoFocus }: CompareDefaultDialogProps) {
  const versions = useVersions(workflowId, true);
  const [sides, setSides] = useState({ base: BASELINE_SIDE, target: DIFF_LIVE });
  return (
    <VersionCompare
      withBaseline
      workflowId={workflowId}
      versions={versions.data?.items ?? []}
      base={sides.base}
      target={sides.target}
      unsaved={unsaved}
      onChange={(base, target) => { setSides({ base, target }); }}
      onClose={onClose}
      onCloseAutoFocus={onCloseAutoFocus}
    />
  );
}
